import React from 'react'
import { IconProps } from './icons.models'

export const SentIcon: React.FC<IconProps> = ({
    width = 16,
    height = 16,
    fillColor = '#00A63E',
}) => {
    return (
        <svg width={width} height={height} viewBox="0 0 16 16" fill="none">
            <g clipPath="url(#clip0_611_1882)">
                <path d="M9.68924 14.4577C9.71456 14.5208 9.75859 14.5747 9.81542 14.6121C9.87224 14.6494 9.93914 14.6685 10.0071 14.6668C10.0751 14.665 10.141 14.6426 10.1958 14.6023C10.2506 14.5621 10.2918 14.506 10.3139 14.4417L14.6472 1.77503C14.6686 1.71596 14.6726 1.65203 14.659 1.59073C14.6453 1.52943 14.6145 1.47329 14.57 1.42888C14.5256 1.38447 14.4695 1.35363 14.4082 1.33996C14.3469 1.32629 14.283 1.33036 14.2239 1.3517L1.55723 5.68503C1.4929 5.70709 1.43685 5.74831 1.39662 5.80314C1.35638 5.85798 1.33388 5.92381 1.33214 5.9918C1.3304 6.05979 1.3495 6.12669 1.38687 6.18351C1.42425 6.24034 1.47811 6.28437 1.54123 6.3097L6.8279 8.4297C6.99503 8.49661 7.14687 8.59667 7.27428 8.72385C7.40169 8.85103 7.50202 9.00269 7.56924 9.1697L9.68924 14.4577Z" stroke={fillColor} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M14.5707 1.43164L7.27734 8.72431" stroke={fillColor} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_611_1882">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}
